import SliderHandle from './SliderHandle.jsx';

export default SliderHandle;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Slider/SliderHandle/index.js